import axios from './api';
import Vue from 'vue';
import { cd } from 'shelljs';
export function AIEWallet(cb) {
  axios(
    'clientPaymentCenter.getTheAieWallets',
    { userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));
}

/**
 * @function allProduct - 获取pcx所有的产品列表
 * @param {function} cb - 回调函数
 */
export const allProduct = () =>
  axios(
    'Product.getPCXProductListByParentId',
    { parentId: '0', userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  );

/**
 * @function productCategoryList - 根据父级id获取产品分类列表
 * @param {string} parentId - 父级产品id
 * @param {function} cb - 回调函数
 */
export const productCategoryList = (parentId, cb) =>
  axios(
    'Product.getPCXProductListByParentId',
    { parentId, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function productVersionList - 获取分类下产品套餐的数据
 * @param {string} subjectId - 学科id
 * @param {string} versionId - 套餐id 默认为0全部
 * @param {function} cb - 回调函数
 */
export const productVersionList = (subjectId, versionId, brank, cb) =>
  axios(
    'Product.getNewPCXProductAllListByProductId',
    { subjectId, versionId, brank, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function productWalletList - 获取产品ids的钱包信息
 * @param {array} productIds - 产品id数组
 * @param {function} cb - 回调函数
 */
export const productWalletList = (productIds, cb) =>
  axios(
    'Product.getProductWalletsByProductIdArray',
    { productIds, simpleUserId: Vue.prototype.get_simpleUser.userId },
    { load: true }
  ).then(r => cb(r));

/**
 * @function allPCXWalletInfo - 获取所有的钱包信息
 * @param {function} cb 回调函数
 */
export const allPCXWalletInfo = cb =>
  axios(
    'Product.getPCXProductListByParentId',
    { parentId: '0', userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => {
    if (r.code !== '000') {
      this.$message({ type: 'error', message: r.msg });
      return;
    }
    let allWalletIds = ['0'];
    r.productList.map(i => allWalletIds.push(i.id));
    productWalletList(allWalletIds, e => cb(e));
  });

/**
 * @function getAgentBizConditionListPCX - 获取当前用户的下级
 * @param {function} cb - 回调函数
 */
export const getAgentBizConditionListPCX = cb =>
  axios(
    'trade.getAgentBizConditionListPCX',
    {
      agentBizId: Vue.prototype.get_simpleUser.userId,
      condition: null,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getAgentBizConsumeInfoPCX - 获取用户余额
 * @param {function} cb - 回调函数
 */
export const getAgentBizConsumeInfoPCX = (userId, cb) =>
  axios(
    'clientPaymentCenter.getAgentBizConsumeInfoPCX',
    {
      userId
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function pcxAgentRecharge - 评测学上下级充值
 * @param {function} cb - 回调函数
 */
export const pcxAgentRecharge = (agentUserId, amount, remarks, cb) =>
  axios(
    'clientPaymentCenter.pcxAgentRecharge',
    {
      agentUserId,
      amount,
      remarks,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getRechargeAuditList - 充值审核列表
 * @param {function} cb - 回调函数
 */
export const getRechargeAuditList = (status, startDate, endDate, pageSize, pageNum, cb) =>
  axios(
    'clientPaymentCenter.getRechargeAuditList',
    {
      status,
      startDate,
      endDate,
      pageSize,
      pageNum
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getRechargeAuditPagin - 充值审核列表分页信息
 * @param {function} cb - 回调函数
 */
export const getRechargeAuditPagin = (status, startDate, endDate, pageSize, cb) =>
  axios(
    'clientPaymentCenter.getRechargeAuditPagin',
    {
      status,
      startDate,
      endDate,
      pageSize
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getRechargeAuditDetail - 充值审核列表分页信息
 * @param {function} cb - 回调函数
 */
export const getRechargeAuditDetail = (id, cb) =>
  axios(
    'clientPaymentCenter.getRechargeAuditDetail',
    {
      id
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function approveRechargeAudit - 通过扣费审核
 * @param {function} cb - 回调函数
 */
export const approveRechargeAudit = (id, description, cb) =>
  axios(
    'clientPaymentCenter.approveRechargeAudit',
    {
      id,
      description,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function rejectRechargeAudit - 拒绝扣费审核
 * @param {function} cb - 回调函数
 */
export const rejectRechargeAudit = (id, description, cb) =>
  axios(
    'clientPaymentCenter.rejectRechargeAudit',
    {
      id,
      description,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function pcxHeadRechargeAgent - 评测学总部给下级充值
 * @param {function} cb - 回调函数
 */
export const pcxHeadRechargeAgent = (agentUserId, amount, remarks, cb) =>
  axios(
    'clientPaymentCenter.pcxHeadRechargeAgent',
    {
      agentUserId,
      amount,
      remarks,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getRechargeList - 充值记录列表分页信息
 * @param {function} cb - 回调函数
 */
export const getRechargeList = (userId, type, status, startDate, endDate, pageSize, pageNum, cb) =>
  axios(
    'clientPaymentCenter.getRechargeList',
    {
      userId,
      type,
      status,
      startDate,
      endDate,
      pageSize,
      pageNum
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getRechargePagin - 充值记录列表
 * @param {function} cb - 回调函数
 */
export const getRechargePagin = (userId, type, status, startDate, endDate, pageSize, cb) =>
  axios(
    'clientPaymentCenter.getRechargePagin',
    {
      userId,
      type,
      status,
      startDate,
      endDate,
      pageSize
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getUserArrearsInfo - 查询指定用户欠款信息
 * @param {function} cb - 回调函数
 */
export const getUserArrearsInfo = (productCode, userId, cb) =>
  axios(
    'clientPaymentCenter.getUserArrearsInfo',
    {
      productCode,
      userId
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function listByUserProduct - 查询指定用户欠款信息
 * @param {function} cb - 回调函数
 */
export const listByUserProduct = (type, productCode, cb) =>
  axios(
    'clientPaymentCenter.listByUserProduct',
    {
      type,
      productCode,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getSuperAgentBizsByMPhoneOrNumberPCX - 搜索下级
 * @param {function} cb - 回调函数
 */
export const getSuperAgentBizsByMPhoneOrNumberPCX = (phoneOrNumber, cb) =>
  axios(
    'trade.getSuperAgentBizsByMPhoneOrNumberPCX',
    {
      phoneOrNumber,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function transferCommisionToArrears - 转移佣金到欠款
 * @param {function} cb - 回调函数
 */
export const transferCommisionToArrears = (productCode, transferAmount, cb) =>
  axios(
    'trade.transferCommisionToArrears',
    {
      productCode,
      transferAmount,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function saveUserArrears - 追加用户欠款
 * @param {function} cb - 回调函数
 */
export const saveUserArrears = (arrearsAmount, arrearsUserId, productCode, cb) =>
  axios(
    'clientPaymentCenter.saveUserArrears',
    {
      arrearsAmount,
      arrearsUserId,
      productCode,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getAgentRechargeCost - 返回用户充值的扣除成本
 * @param {function} cb - 回调函数
 */
export const getAgentRechargeCost = (lowerUserId, amount, cb) =>
  axios(
    'clientPaymentCenter.getAgentRechargeCost',
    {
      userId: Vue.prototype.get_simpleUser.userId,
      lowerUserId,
      amount
    },
    { load: true }
  ).then(r => cb(r));

/*********************************************************艾速度*************************************************/
export function ASDWallet(productCode, cb) {
  axios(
    'Product.getProductWalletsByProductCode',
    { code: productCode, userId: [Vue.prototype.get_simpleUser.userId] },
    { load: true }
  ).then(r => cb(r));
}
/**
 * @function allASDProduct - 获取asd所有的产品列表
 * @param {function} cb - 回调函数
 */
export const allASDProduct = () =>
  axios(
    'Product.getASDProductListByParentId',
    { parentId: '0', userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  );

/**
 * @function productASDCategoryList - 根据父级id获取产品分类列表
 * @param {string} parentId - 父级产品id
 * @param {function} cb - 回调函数
 */
export const productASDCategoryList = (parentId, productCode, cb) =>
  axios(
    'Product.getASDProductListByParentId',
    { parentId, productCode, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function productASDVersionList - 获取分类下产品套餐的数据
 * @param {string} subjectId - 学科id
 * @param {string} versionId - 套餐id 默认为0全部
 * @param {function} cb - 回调函数
 */
export const productASDVersionList = (subjectId, versionId, productCode, cb) =>
  axios(
    'Product.getNewASDProductAllListByProductId',
    { subjectId, versionId, productCode, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function productVersionList - 获取分类下产品套餐的数据
 * @param {string} subjectId - 学科id
 * @param {string} versionId - 套餐id 默认为0全部
 * @param {function} cb - 回调函数
 */
export const getASDAgentFloat = (productCode, cb) =>
  axios(
    'Product.getASDAgentFloat',
    { productCode, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**********************************************学生产品与钱包与搜索*********************************************************************/

/**
 * @function getAIQAProductListByParentId - 获取所有的产品列表
 * @param {function} cb - 回调函数
 */
export const getAIQAProductListByParentId = () =>
  axios(
    'Product.getAIQAProductListByParentId',
    { parentId: '0', userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  );

/**
 * @function addProductType - 添加产品
 * @param {string} products - 产品信息
 * @param {number} isVisible - 产品学生是否可见
 * @param {function} cb - 回调函数
 * */
export const addProductType = cb =>
  axios(
    'Product.addProductType',
    { userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function AIQAWallet - 查询智能答疑钱包
 * @param {function} cb - 回调函数
 * */
export function AIQAWallet(code, cb) {
  axios(
    'Product.getProductWalletsByProductCode',
    { code, userId: [Vue.prototype.get_simpleUser.userId] },
    { load: true }
  ).then(r => cb(r));
}

/**
 * @function productsOpenWalletByProductCode - 创建钱包
 * */
export const productsOpenWalletByProductCode = (productCode, cb) =>
  axios(
    'Product.productsOpenWalletByProductCode',
    { productCode, userId: Vue.prototype.get_simpleUser.userId },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getAllWalletsByAgentUserId - 获取所有钱包
 * */
export const getAllWalletsByAgentUserId = cb =>
  axios(
    'Product.getAllWalletsByAgentUserId',
    { userId: Vue.prototype.get_simpleUser.userId, user: Vue.prototype.get_simpleUser },
    { load: true }
  );

/**
 * @function getListSalesOverviewForUser - 查询当前登录用户业绩概览
 * @param {Date} startDate - 开始时间
 * @param {Date} endDate - 结束时间
 * */
export const getListSalesOverviewForUser = (startDate, endDate, cb) =>
  axios(
    'clientPaymentCenter.listSalesOverviewForUser',
    {
      userId: Vue.prototype.get_simpleUser.userId,
      startDate,
      endDate,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getListSalesDetailsForUser - 查询当前登录用户业绩详情
 * @param {Date} startDate - 开始时间
 * @param {Date} endDate - 结束时间
 * */
export const getListSalesDetailsForUser = (startDate, endDate, cb) =>
  axios(
    'clientPaymentCenter.listSalesDetailsForUser',
    {
      userId: Vue.prototype.get_simpleUser.userId,
      startDate,
      endDate,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getListSalesOfDirectRecommenderForUser - 查询当前用户下面直接推荐人的业绩概览
 * @param {Date} startDate - 开始时间
 * @param {Date} endDate - 结束时间
 * */
export const getListSalesOfDirectRecommenderForUser = (startDate, endDate, cb) =>
  axios(
    'clientPaymentCenter.listSalesOfDirectRecommenderForUser',
    {
      userId: Vue.prototype.get_simpleUser.userId,
      startDate,
      endDate,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getListSalesOfInDirectRecommenderForUser - 查询当前用户下面指定直接推荐人下面的间接推荐人业绩概览
 * @param {string} directUserId-前用户下面指定直接推荐人的userId
 * @param {Date} startDate - 开始时间
 * @param {Date} endDate - 结束时间
 * */
export const getListSalesOfInDirectRecommenderForUser = (directUserId, startDate, endDate, cb) =>
  axios(
    'clientPaymentCenter.listSalesOfInDirectRecommenderForUser',
    {
      userId: Vue.prototype.get_simpleUser.userId,
      directUserId,
      startDate,
      endDate,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getUsersBaseByIds - 通过userids查询用户详情
 * @param {Array} userIds - 要查询的用户id集合
 * */
export const getUsersBaseByIds = (userIds, cb) =>
  axios(
    'client.usersBaseByIds',
    { userIds, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getListSalesDetailsOfInDirectRecommenderForUser - 查询当前用户下面指定直接推荐人的业绩详情
 * @param {string} directUserId-前用户下面指定直接推荐人的userId
 * @param {Date} startDate - 开始时间
 * @param {Date} endDate - 结束时间
 * */
export const getListSalesDetailsOfInDirectRecommenderForUser = (
  directUserId,
  startDate,
  endDate,
  cb
) =>
  axios(
    'clientPaymentCenter.listSalesDetailsOfInDirectRecommenderForUser',
    {
      userId: Vue.prototype.get_simpleUser.userId,
      directUserId,
      startDate,
      endDate,
      userExtend: Vue.prototype.get_simpleUser
    },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getUserBaseInfo - 查询指定账号基本信息
 * @param {number} account-电话或用户Number号
 * */
export const getUserBaseInfo = (account, cb) =>
  axios(
    'client.getUserBaseInfo',
    { account, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function getListAllRecommendUser - 查询所有推荐大使
 * @param {number} account-电话或用户Number号
 * */
export const getListAllRecommendUser = cb =>
  axios(
    'client.listAllRecommendUser',
    { userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));

/**
 * @function updateUserRecommenderForUser - 查询所有推荐大使
 * @param {string} userId-需要被设置上级推荐大使的用户
 * @param {string} recommenderUserId-上级推荐大使的ID
 * */
export const updateUserRecommenderForUser = (userId, recommenderUserId, cb) =>
  axios(
    'client.updateUserRecommenderForUser',
    { userId, recommenderUserId, userExtend: Vue.prototype.get_simpleUser },
    { load: true }
  ).then(r => cb(r));



// WEBPACK FOOTER //
// ./src/utils/wallet.js